// Industrial B2B theme
(function () {
  // Product image thumbnail switcher
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.thumb');
    if (!thumb) return;
    var main = document.getElementById('ProductMainImage');
    if (main) {
      main.src = thumb.getAttribute('data-full');
      document.querySelectorAll('.thumb').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    }
  });

  // Variant selection -> hidden id input (simple single-select mapping)
  var form = document.getElementById('ProductForm');
  if (form) {
    var selects = form.querySelectorAll('select[data-option-index]');
    var variants = window.__productVariants || [];
    // Theme ships without variant JSON injection; Shopify form default works for single-variant products.
  }
})();
